import Unit from "./Unit";

export default function BuildingC({ units, onToggle, onName }) {
  return (
    <div className="building">
      <h3>Building C</h3>

      <div className="grid grid-8">
        <div className="split">
          <Unit number="8" data={units["8"]} onToggle={onToggle} onName={onName} />
          <Unit number="9" data={units["9"]} onToggle={onToggle} onName={onName} />
        </div>

        {["7","6","5","4","3","2","1"].map((n) => (
          <Unit key={n} number={n} data={units[n]} onToggle={onToggle} onName={onName} tall />
        ))}
      </div>
    </div>
  );
}
